module.exports = __webpack_public_path__ + "static/media/john-henry.6775ab6c.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/img/speakers/john-henry.png
// module id = 269
// module chunks = 0